<template>
  <div class="custTabsMain">
    <div class="custCol">
      <div class="custRow"> <InputQuery placeholder="Billing Cust Code" :isRequired="true"
          :items="data['customer']" itemKey="Customer Code" descKey="Customer Name"/> </div>
      <div class="custRow"> <InputQuery placeholder="Payment Type"
          :items="data['paymenttype']" itemKey="Payment Type" descKey="Description"/> </div>
      <div class="custRow"> <Input placeholder="Bill Term"/> </div>
      <div class="custRow"> <Dropdown placeholder="Bill Type"
          :items="data['billingtype']" itemKey="Description"/> </div> <!-- Dropdown -->
      <div class="custRow"> <Dropdown placeholder="Billing Format"
          :items="data['billingformat']" itemKey="Description"/> </div> <!-- Dropdown -->
      <div class="custRow"> <InputQuery placeholder="Default Currency"
          :items="data['currency']" itemKey="Currency Code" descKey="Description"/> </div>
      <div class="custRow"> <InputQuery placeholder="GL Acc Code" :isRequired="true"
          :items="data['glaccount']" itemKey="Acc No" descKey="Description"/> </div>
      <div class="custRow"> <CheckBox title="Print Price on CDA"/> </div>
      <div class="custRow"> <Dropdown placeholder="Internal"
          :items="data['internalcusttype']" itemKey="Description"/> </div> <!-- Dropdown -->
      <div class="custRow"> <Dropdown placeholder="Depot Storage Bill"
          :items="data['depotstoragebill']" itemKey="Description"/> </div> <!-- Dropdown -->
      <div class="custRow"> <Input placeholder="Trailer Detention"/> </div>
      <div class="custRow"> <Input placeholder="Staging"/> </div>
      <div class="custRow"> 
        <Input placeholder="Billing Schedule" :isDisabled="true"/>
        <button style="max-width: 200px"> Change Billing Schedule </button>
      </div>
      <div class="custRow"> <Dropdown placeholder="Invoice Option"
          :items="data['invoiceoption']" itemKey="Description"/> </div> <!-- Dropdown -->
    </div>
    
    <Loader :isVisible="loadShow" :loadingText="loadText" />
  </div>
</template>

<script>
  /* eslint-disable */
  import Menu from '@/components/Menus.vue';
  import Tabulator from '@/components/Tabulator.vue';
  import EntryPopup from '@/components/EntryPopup.vue';
  import TabView from '@/components/TabView.vue';
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import Loader from '@/components/Loader.vue';
  import Address from '@/components/AddressForm.vue';
  import Radio from '@/components/RadioButton.vue';
  import CheckBox from '@/components/CheckBox.vue';
  
  export default {
    name: 'customer',
    components: {
      Menu, Tabulator, EntryPopup, Input, InputQuery, DateTime, Dropdown, TabView, Loader, Address, Radio, CheckBox
    },
    data() {
      return {
        //-------- Main Data
        localData: {
          'cu_BillTo' : '',
          'DefaultPayType' : '',
          'BillingTerm' : '',
          'BillingType' : '',
          'BillingFmt' : '',
          'DefaultCur' : '',
          'Cu_GLAcc' : '',
          'CDAPrintPrice' : '',
          'InternalCust' : '',
          'DepotStorageBillType' : '',
          'TrDetFreeDaysOrHrs' : '',
          'TrkStgFreeDaysOrHrs' : '',
          'abBillingCategory' : '',
          'abInvoiceOption' : '',
        },

        localDataStorage: {
          'customer' : [],
          'paymenttype' : [],
          'billingtype' : [],
          'billingformat' : [],
          'currency' : [],
          'glaccount' : [],
          'internalcusttype' : [],
          'depotstoragebill' : [],
          'invoiceoption' : [],
        },

        //-------- Radio button Data
        radioButtons: [
          { title: 'Both', value: '0' }, 
          { title: 'Customer (Shipper / Consignee)', value: '1' }, 
          { title: 'ArCustomer (Bill To)', value: '1'}],
        radioChecked: [],

      }
    },
    props: {
      //-------- Main Props
      data: { type: Object, default: function () { return {} } },
      viewMode: { type: Boolean, default: false },
    },
    mounted() {
      
    },
    beforeDestroy() {
      
    },
    methods: {
      custBtnClick: async function(btn) {
        switch(btn) {
          case 'test':
            console.log(this.data);
            break;
        }
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .custTabsMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .custCol {
    width: auto;
    height: 100%;
    max-width: 40%;
    margin: 0 2px;
    flex: 1;
  }

  .custRow {
    width: 100%;
    height: auto;
    min-height: 30px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .custRow * {
    height: 100%;
    margin: 0 4px;
    flex: 1;
  }

</style>
